module.exports = __webpack_public_path__ + "img/videoPlay.75a7f5a5.png";